import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

export const Investor: ImportTemplateField[] = [
  {
    toField: "investorKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "name",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
];
